import { useEffect, useState } from 'react';
import CollapsableProgramWeek from '@ecosystems/programs/CollapsableProgramWeek';
import CollapsableVideoList from '@ecosystems/programs/CollapsableVideoList';
import ProgramRecommendation from '@ecosystems/programs/ProgramRecommendation';
import { ProgramCategory, WeeklyProgramQuery } from '@gql/generated';

type Props = {
  programCategory: ProgramCategory;
  program: WeeklyProgramQuery['weeklyProgram'];
  programId: string;
  stepSlug: string;
  videoSlug: string;
};
export const WeeklySteps = (props: Props) => {
  const { programCategory, program, programId, stepSlug, videoSlug } = props;
  const [openWeek, setOpenWeek] = useState(null);

  const onWeekOpenChange = (open, weekId) => {
    if (open) {
      setOpenWeek(weekId);
    } else {
      setOpenWeek(null);
    }
  };

  useEffect(() => {
    const currentWeekIndex = program?.weeks?.findIndex(
      (week) => week.slug === stepSlug
    );
    setOpenWeek(currentWeekIndex);
  }, [stepSlug, program?.id]);

  return (
    <>
      {program.recomendation ? (
        <ProgramRecommendation recommendation={program.recomendation} />
      ) : null}
      <CollapsableVideoList programCategory={programCategory}>
        {[
          ...program.weeks.map((week, weekIndex) => {
            return (
              <CollapsableProgramWeek
                key={weekIndex}
                programId={programId as string}
                weekIndex={weekIndex}
                data={{
                  label: week.label,
                  slug: week.slug,
                  elements: week.elements,
                  videosCount: week['videosCount'],
                  duration: week['duration'],
                }}
                programCategory={programCategory}
                stepSlug={stepSlug}
                elementSlug={videoSlug}
                onOpenChange={(open) => onWeekOpenChange(open, weekIndex)}
                isOpen={openWeek === weekIndex}
              />
            );
          }),
          program?.['outro']?.videos ? (
            <CollapsableProgramWeek
              key="outro"
              programId={programId as string}
              weekIndex={program.weeks.length}
              data={{
                label: program.outro.label,
                slug: program.outro.slug,
                elements: program.outro.videos,
                videosCount: program.outro['videosCount'],
                duration: program.outro['duration'],
              }}
              programCategory={programCategory}
              stepSlug={stepSlug}
              elementSlug={videoSlug}
              onOpenChange={(open) =>
                onWeekOpenChange(open, program.weeks.length)
              }
              isOpen={openWeek === program.weeks.length}
            />
          ) : null,
        ].filter((item) => !!item)}
      </CollapsableVideoList>
    </>
  );
};
